export default (res, arr, set) => {
  const { id, total, stage_3 } = res;

  const updated = arr.map((key) =>
    id === key.id ? { ...key, total, stage_3 } : key
  );

  set(updated);
};
